<template>  
    <div id="book-menu" class="custom-scroller" :class="{ 'active' : $store.state.navStates.isBookNavOpen }">
      <div class="closer"><img src="~@/assets/icons/close-x.svg" alt=""  @click.stop="hideMenu" /></div>
        <ul>
            <li v-for="l0Item in level0" :key="l0Item.href" @click.stop="loadText(l0Item.href)" class="first" :class="{selected:l0Item.href == $store.state.activeTexts.actBookTarget}" >                   
                <span class="title"  v-html="l0Item.text" ></span>
                <div class="mobile-nav-toggle" v-if="l0Item.class==='sub'" @click.stop="l0Item.isShow = !l0Item.isShow" ><i class="zf zf-chevron-right" :class="{active:l0Item.isShow}"></i></div>
                <transition name="slide">
                <ul  class="child" v-if="l0Item.isShow">
                    <li v-for="l1Item in l0Item.level1" :key="l1Item.href" @click.stop="loadText(l1Item.href )" :class="{selected:l1Item.href == $store.state.activeTexts.actBookTarget}" >                            
                        <span class="menuitem" v-html="l1Item.text"  v-bind:class="{'nuronline': l1Item.nurOnline,  '': !l1Item.nurOnline}" ></span><!--<span v-html="l1Item.text" ></span>-->
                        <div class="mobile-nav-toggle"  v-if="l1Item.class === 'sub'" @click.stop="l1Item.isShow = !l1Item.isShow" ><i class="zf zf-chevron-right" :class="{active:l1Item.isShow}"></i></div>
                        <transition name="slide">
                        <ul class="child" v-if="l1Item.isShow">
                            <li v-for="l2Item in l1Item.level2" :key="l2Item.href" @click.stop="loadText(l2Item.href)" :class="{selected:l2Item.href == $store.state.activeTexts.actBookTarget}" >                                       
                                <span class="menuitem"  v-html="l2Item.text" v-bind:class="{'nuronline': l2Item.nurOnline,  '': !l2Item.nurOnline}"></span>
                                <div class="mobile-nav-toggle" v-if="l2Item.class === 'sub'" @click.stop="l2Item.isShow = !l2Item.isShow" ><i class="zf zf-chevron-right" :class="{active:l2Item.isShow}"></i></div>
                                <transition name="slide">
                                <ul class="child" v-if="l2Item.isShow">
                                    <li v-for="l3Item in l2Item.level3" :key="l3Item.href" @click.stop="loadText(l3Item.href)" :class="{selected:l3Item.href == $store.state.activeTexts.actBookTarget}" >                                                      
                                        <span class="menuitem"  v-html="l3Item.text"  v-bind:class="{'nuronline': l3Item.nurOnline,  '': !l3Item.nurOnline}"></span>
                                        <div class="mobile-nav-toggle" v-if="l3Item.class === 'sub'" @click.stop="l3Item.isShow = !l3Item.isShow" ><i class="zf zf-chevron-right" :class="{active:l3Item.isShow}"></i></div>
                                        <transition name="slide">
                                        <ul class="child" v-if="l3Item.isShow"  >
                                            <li v-for="l4Item in l3Item.level4" :key="l4Item.href" @click.stop="loadText(l4Item.href)" :class="{selected:l4Item.href == $store.state.activeTexts.actBookTarget}" >  
                                                <span v-html="l4Item.text" v-bind:class="{'nuronline': l4Item.nurOnline,  '': !l4Item.nurOnline}" ></span>                                               
                                            </li>
                                        </ul>
                                        </transition>                                                                                                          
                                    </li>
                                </ul> 
                                </transition>                                                                                  
                            </li>
                        </ul> 
                        </transition>                          
                    </li>
                </ul> 
                </transition >                            
            </li>
        </ul>
    </div>
</template>

<script>
import {  loadHandler, jumpToBookSection, loadBook, lazyload} from "@/components/Scripts/bookClickEventHandler"

    export default {
        name: "BookMenu",
            data() {
                return {
                    level0: []
                };
            },

	methods:{
    loadHandler,jumpToBookSection, loadBook, lazyload, 
      hideMenu() {
          this.$store.commit('changeArchiveNavState', {'active': false, 'type': 'Book'} ) 
      },
      loadText: function(item) {
                
        this.$store.commit('changeArchiveNavState', {'active': false, 'type': 'Book'} )   
         
        if(this.$router.history.current.name == 'text' && this.$router.history.current.hash == "#"+item) {return}

        if(typeof this.$parent.$refs.bookcontainer !== 'undefined') { 
            this.$parent.$refs.bookcontainer.$refs.textcontainer.style.opacity = "0"
            this.$parent.$refs.bookcontainer.$refs.loader.style.display = 'block'
        }
        

        //this.$parent.$parent.$refs.loader.style.display = 'block'
        // transition on opacity in #text-container is .3s  hence setTimeout!
        setTimeout(() => {
          this.$router.push({ 
              name: 'text', 
              hash: "#"+item,
              //query: {id: item.substring(0,1)},
              params: {vol: item.substring(0,1)} },() => {})            
        }, 200)      
      }
    },
    mounted () {
        this.$http.get("/json/tocBook.json")
        .then(response => {
            this.level0 = response.data.level0

            // get flat array of all hrefs in tocBook!
            const getPropValues = (o, prop) => 
            (res => (JSON.stringify(o, (key, value) => 
                (key === prop && res.push(value), value)), res))([]);

            let res = getPropValues(response.data.level0, "href");
            this.$store.commit('updateBookNavHrefArray' , res)
        }) 
    }
    };
    
</script>

<style lang="scss">

//@import "@/assets/css/textcommons.scss";
@import "@/assets/css/_variables.scss";

#book-menu {
    position:fixed;
    top: 0px;
    left: -800px;
    width: 400px;
    height: 100%;
    overflow-y: scroll;
    transition: left .5s ease-out;
    background-color:white;
    border-right: 0.14rem solid #777;
    padding: 8px;
    padding-left: 20px;
    padding-top: 30px;
    padding-right: 20px;
    z-index: 3;
    text-align:left;
    max-width: 450px;
    margin: 0 auto;
    &.active{
        transition: left .3s ease-in;
        left: 0px;
    } 

    .closer {
      position: absolute;
      right: 0px;
      top: 0;
      cursor: pointer;
    }   

    ul {
      margin: 0;
      padding: 0;
      font-family: $font-family-herausgeber-medium;
      color: #000;
      font-size: 1.2rem;
      line-height: 1rem;
      padding-bottom: 8px;
      margin-right: 30px;
    }


    ul {
        cursor: pointer;
        list-style: none;
        padding:0;
        li {
            border-bottom: 0.14rem solid  #777;;
            display: block;
            position: relative;
            //padding: 5px 0 5px 0;
            font-family: $font-family-herausgeber-medium;
            font-size: 1.2rem;
            line-height: 1.3rem;
            margin: 0;

            :hover {
              color: $color-red;
              li {
                color: #777;
                &.selected {
                  color: $color-red;
                }
              }
              li:hover {
                color: $color-red;
                li {                  
                  color: #777;
                  &.selected {
                    color: $color-red;
                  }
                  li:hover {
                    color: $color-red;
                  }
                }
              }            
            }

            &.selected {
                color: $color-red;
                >.mobile-nav-toggle .zf.zf-chevron-right {
                  background: url('~@/assets/icons/nextred.svg');
                }
            }
            span.nuronline {
                border-left: 2px dotted black;
                display: block;
                margin: 5px 0;
                padding-left: 5px !important;               
            }
            span.title {
                display: block;
                padding: 7px 0;
                max-width: calc(100% - 30px);
            }
            span.menuitem {
              display: block;
              padding: 5px 0;
              max-width: calc(100% - 30px);
            }
            .mobile-nav-toggle {
                font-size:20px;
                font-weight: bold;
                position: absolute;
                padding:6px;
                top: 5px;
                right: -35px;
                .zf {
                    width: 1rem;
                    height: 1rem;
                    display:block;                    
                    &.zf-chevron-right{      
                      transition: transform .5s;                
                      background: url('~@/assets/icons/nextgray.svg');
                    }
                    &.zf-chevron-right.active{      
                      transform: rotate(90deg);
                    }                    
                }
                
                &.active  {
                  .zf {                    
                    transform: rotate(90deg);
                  }
                }
              }
            }


            li > ul {margin:0; padding:0 ;  border-top: 0.1rem solid #777;}
            li > ul > li:first-child {border:0;}
            li > ul > li {
                font-family: $font-family-herausgeber-medium;
                font-size: 1rem;
                margin-left:20px;
                border-bottom:0;
                border-top: 0.1rem solid #777;
                color:#777;

            }
            li > ul > li > ul > li {
              font-family: $font-family-herausgeber-regular;
              
            }
        }
}




.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>